Jelly.Utilities.Localize_Currency = function(Namespace) {	
	const currencySymbolOverrides = {'SGD': 'S$'};

	const locale = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en-US';

	document.querySelectorAll(`#${Namespace} .wf-do-format-currency`).forEach((e) => {
		
		if (e.dataset.amount && e.dataset.currencyCode) {
			
			CurrencyCodeClassName = e.dataset.currencyCodeClassName || 'currency';
			AmountClassName = e.dataset.amountClassName || 'amount';

			parts = new Intl.NumberFormat(locale, { style: 'currency', currency: e.dataset.currencyCode.toUpperCase()}).formatToParts(e.dataset.amount);
			let lastPartKind = '';
			html = '';
			parts.forEach((part, partIndex) => {
				if (
					(part.type == 'decimal' && (parts.length < (partIndex + 2) || !parseInt(parts[partIndex + 1].value))) ||
					(part.type == 'fraction' && !parseInt(part.value))
				){
				}
				else {
					partKind = part.type == "currency" ? "currency" : "amount";
					html += (
						partKind != lastPartKind ? (
							lastPartKind ? '</span>' : 
							''
						) + `<span class="${partKind == "currency" ? CurrencyCodeClassName : AmountClassName}">` : 
						''
					)
					+ ((partKind == 'currency' && !!currencySymbolOverrides[part.value]) ? currencySymbolOverrides[part.value] : part.value);

					lastPartKind = partKind
				}
			})
			html += "</span>"
			
			e.innerHTML = html;
		}
	});
}